<template>
    <div id="main-wrapper" :dir="$i18n.locale == 'ar'? 'rtl':'ltr'">
        <NavbarDark/>
        <div class="page-title" :class="{ 'ltr': $i18n.locale === 'en', 'rtl': $i18n.locale === 'ar' }">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <h2 class="ipt-title" >{{$t('ContactUs')}}</h2>
                    </div>
                </div>
            </div>
        </div>

        <section>
            <div class="container">
                <div class="row" >
                    <div class="col-lg-7 col-md-7">
                        <div class="row">
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label class="mb-1">{{ $t('name') }}</label>
                                    <input type="text" class="form-control simple">
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label class="mb-1">{{ $t('email') }}</label>
                                    <input type="email" class="form-control simple">
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="mb-1">{{ $t('address') }}</label>
                            <input type="text" class="form-control simple">
                        </div>
                        <div class="form-group">
                            <label class="mb-1">{{ $t('Messagae') }}</label>
                            <textarea class="form-control simple"></textarea>
                        </div>
                        <div class="form-group">
                            <button class="btn btn-primary px-5 rounded" type="submit">{{ $t('send') }}</button>
                        </div>
                    </div>
                    
                    <div class="col-lg-5 col-md-5">
                        <div class="contact-info">
                            <h2>{{$t('Contact Us – We are Here to Help!')}}</h2>
                            <p>{{$t('Have a question or need more information? Don’t hesitate to reach out! The Ruqm team is ready to answer all your inquiries and assist you in finding the best opportunities in the world of exhibitions and events.')}}</p>
                            <div class="cn-info-detail mt-4">
                                <div class="cn-info-icon">
                                    <i class="fa-solid fa-house"></i>
                                </div>
                                <div class="cn-info-content">
                                    <h4 class="cn-info-title">{{$t('Our Website')}}</h4><br>{{$t('')}}</div>
                            </div>
                            
                            <div class="cn-info-detail">
                                <div class="cn-info-icon">
                                    <i class="fa-solid fa-envelope-circle-check"></i>
                                </div>
                                <div class="cn-info-content"><h4 class="cn-info-title">{{ $t('Send Us a Message') }}</h4>info@ruqm.me<br>info@ruqm.me</div>
                            </div>
                            
                            <div class="cn-info-detail">
                                <div class="cn-info-icon">
                                    <i class="fa-solid fa-phone-volume"></i>
                                </div>
                                <div class="cn-info-content"><h4 class="cn-info-title">{{$t('ContactUs')}}</h4>00963987004477</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <FooterTop :bg="'theme-bg'"/>
        <FooterDark/>
        <ScrollToTop/>
    </div>
</template>

<script setup>
import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import NavbarDark from '@/components/navbar/navbar-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';

import { computed } from 'vue';
import { useHead } from '@vueuse/head'
import { useRoute } from 'vue-router'
const route = useRoute()
const baseUrl = 'https://ruqm.me'

const canonicalUrl = computed(() =>
  `${baseUrl}${route.path}`
)

const supportedLocales = ['en', 'ar']

const hreflangLinks = computed(() => {
  const pathWithoutLang = route.path.replace(/^\/(en|ar)/, '')

  return supportedLocales.map(lang => ({
    rel: 'alternate',
    hreflang: lang,
    href: `${baseUrl}/${lang}${pathWithoutLang}`
  }))
})
useHead(() => ({
  link: [
    { rel: 'canonical', href: canonicalUrl.value },
    ...hreflangLinks.value,
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${baseUrl}/en${route.path.replace(/^\/(en|ar)/, '')}`
    }
  ]
}))
</script>
